@if (value() !== null && value() !== undefined) {
  <span class="chip" [class.up]="isUp()" [class.down]="isDown()" [class.flat]="isFlat()">
    <span class="arrow" aria-hidden="true">{{ isUp() ? '▲' : isDown() ? '▼' : '■' }}</span>
    {{ text() }}
    <span class="tag">{{ label() }}</span>
  </span>
}
